class ShadeFinderQuizSkintone extends window.BAO.CustomElement() {
  setupListeners() {
    super.setupListeners()

    this.setupSkintoneChangeListeners()
    this.setupContinueListeners()
    this.setupBackListeners()

    // Listen for when this step is active
    this._observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = mutation.target.classList.contains('is-active')
          this.carouselManager(isActive)
        }
      }
    })

    this._observer.observe(this, { attributes: true })

    // Setup carousel 'dots'
    const dotElements = this.els?.dot?.elements
    if (dotElements) {
      dotElements.forEach(dot => {
        this.listeners.add(dot, 'click', () => {
          if (this.carousel) {
            dotElements.forEach(d => d.removeAttribute('aria-current'))
            dot.setAttribute('aria-current', 'true')

            const dotIndex = parseInt(dot.getAttribute('data-dot-index'))
            for (let i = 0; i <= dotIndex; i++) {
              this.carousel.moveToIdx(i)
            }

            const slides = this.els?.['slide-input']?.elements
            if (slides) {
              slides.forEach(slide => {
                const slideIndex = parseInt(slide.getAttribute('data-slide-index'))
                if (slideIndex === dotIndex) {
                  slide.click()
                }
              })
            }
          }
        })
      })
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this._observer?.disconnect()
  }

  setupSkintoneChangeListeners () {
    const skintoneGroupRadioEl = document.querySelectorAll('[data-quiz-content-radio-input]')

    skintoneGroupRadioEl.forEach((radioEl) => {
      this.listeners.add(radioEl, 'click', () => {
        const skinBaseVariantId = radioEl.getAttribute('data-skin-base-variant-id')
        const concealerTrueMatchVariantId = radioEl.getAttribute('data-concealer-true-match-variant-id')
        const concealerLighterShadeVariantId = radioEl.getAttribute('data-concealer-lighter-shade-variant-id')
        const shadeMatrixId = radioEl.getAttribute('data-shade-matrix-id')
        const slideIndex = radioEl.getAttribute('data-slide-index')

        const continueBtns = document.querySelectorAll('[data-shade-finder-continue-button]')
        continueBtns.forEach((continueBtn) => {
          continueBtn.setAttribute('data-skin-base-variant-id', skinBaseVariantId)
          continueBtn.setAttribute('data-concealer-true-match-variant-id', concealerTrueMatchVariantId)
          continueBtn.setAttribute('data-concealer-lighter-shade-variant-id', concealerLighterShadeVariantId)
          continueBtn.setAttribute('data-shade-matrix-id', shadeMatrixId)
          continueBtn.setAttribute('data-selected-skintone-index', slideIndex)
        })

        const skintoneContinueButtons = document.querySelectorAll('[data-modelfit-section-trigger]')
        skintoneContinueButtons.forEach((skinToneContinueButton) => {
          skinToneContinueButton.removeAttribute('disabled')
        })

      })
    })
  }

  setupContinueListeners () {
    const continueBtns = document.querySelectorAll('[data-modelfit-section-trigger]')

    continueBtns.forEach((continueBtn) => {
      this.listeners.add(continueBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-skintone').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-modelfits').classList.add('is-active')

        const continueBtnSkintoneVal = continueBtn.getAttribute('data-modelfit-skintone-group')
        const modelfitGroupSkintoneGroupVal = document.querySelectorAll('[data-model-fit-skintone]')

        modelfitGroupSkintoneGroupVal.forEach((modelfitGroupEl) => {
          modelfitGroupEl.setAttribute('aria-hidden', 'true')
          if (continueBtnSkintoneVal === modelfitGroupEl.getAttribute('data-model-fit-skintone')) {
            modelfitGroupEl.removeAttribute('aria-hidden')
          }
        })
      })
    })
  }

  setupBackListeners () {
    const backBtn = document.querySelector('[data-skintone-section-back-trigger]')

    if (!backBtn) return

    this.listeners.add(backBtn, 'click', () => {
      document.querySelector('shade-finder-quiz-skintone').classList.remove('is-active')
      document.querySelector('shade-finder-quiz-start').classList.add('is-active')

      window.scrollTo(0, 0)
    })
  }

  carouselManager(pageActive) {
    if (pageActive === true) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
      this.carousel = this.setupCarousel()
    } else {
      if (this.carousel) {
        this.carousel.destroy()
      }
    }
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.5,
          spacing: 2,
          origin: 'center',
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 6.5,
            },
            loop: false,
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('shade-finder-quiz-skintone')) {
  customElements.define('shade-finder-quiz-skintone', ShadeFinderQuizSkintone)
}
